import { NgModule } from "@angular/core";
import { MenuModule } from "../menu/menu.module";
import { ERTEducationComponent } from "./ert-education.component";
import { SharedImportsModule } from "../shared/shared-imports.module";
import { TableControlsComponent } from "../shared/table-controls/table-controls.component";
import { ErtEducationViewComponent } from "./ert-education-view/ert-education-view.component";
import { CommonModule } from "@angular/common";
import { SharedModule } from "../shared.module";
import { ERTEducationFormComponent } from "./ert-education-form/ert-education-form.component";
import { SelectUserComponent } from "./select-user/select-user.component";

const componentList = [
  ERTEducationComponent,
  ErtEducationViewComponent,
  ERTEducationFormComponent,
  SelectUserComponent,
];

@NgModule({
  imports: [
    MenuModule,
    SharedImportsModule,
    TableControlsComponent,
    CommonModule,
    SharedModule,
  ],
  declarations: [componentList],
})
export class ERTEducationModule {}
